import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לפחד בשם (ולא לברוח ממנו)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק להתעלם מהפחד.",
      "אני לא מנסה להרגיע אותו — אני מקשיב לו."
    ],
      [
      "היום אני מפסיק להתעלם מהפחד.",
      "אני לא מנסה להרגיע אותו — אני מקשיב לו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "ואומר בלב:",
      "“זה פחד. הוא לא נבואה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "ואומר בלב:",
      "“זה פחד. הוא לא נבואה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה — בשבילי\nאני שואל את עצמי:\nמה בדיוק המשפט שמפחיד אותי?\n(“אני לא אמצא שוב אהבה”, “משהו בי דפוק”, “כולם מצאו חוץ ממני”)",
      "אני שואל את עצמי:\nאיפה בגוף הפחד הזה יושב?\n(חזה / בטן / גרון / כתפיים)",
      "אני שואל את עצמי:\nמתי הפחד הזה מופיע הכי חזק?\n(בלילה? בדייטים? כשרואה אחרים?)"
    ],
      [
      "כתיבה — בשבילי\nאני שואל את עצמי:\nמה בדיוק המשפט שמפחיד אותי?\n(“אני לא אמצא שוב אהבה”, “משהו בי דפוק”, “כולם מצאו חוץ ממני”)",
      "אני שואל את עצמי:\nאיפה בגוף הפחד הזה יושב?\n(חזה / בטן / גרון / כתפיים)",
      "אני שואל את עצמי:\nמתי הפחד הזה מופיע הכי חזק?\n(בלילה? בדייטים? כשרואה אחרים?)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פחד לא אומר אמת.",
      "פחד אומר: “כואב לי, ואני בוחר/ת ביטחון”."
    ],
      [
      "סגירה",
      "פחד לא אומר אמת.",
      "פחד אומר: “כואב לי, ואני בוחר/ת ביטחון”."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום — יד על הגוף + משפט:",
      "פעם אחת היום — יד על הגוף + משפט:"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הפחד כקול, לא כעובדה",
    opening: localizedGenderNode(
      [
      "היום אני לומד להבדיל בין קול פנימי לבין מציאות."
    ],
      [
      "היום אני לומד להבדיל בין קול פנימי לבין מציאות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת.",
      "“לא כל מחשבה היא אמת.”"
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת.",
      "“לא כל מחשבה היא אמת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הפחד אומר לי על העתיד שלי?",
      "איזו עובדה אמיתית יש לי כרגע — בלי פרשנות?",
      "איזה חלק בי מדבר דרך הפחד הזה — ואיזו אמת עדינה אחת אני יכול לבחור היום במקום הקול המפחיד?\n(הילד/ה שננטש, החלק שהתאכזב, החלק העייף; משפט אחד בלבד)"
    ],
      [
      "כתיבה\nמה הפחד אומר לי על העתיד שלי?",
      "איזו עובדה אמיתית יש לי כרגע — בלי פרשנות?",
      "איזה חלק בי מדבר דרך הפחד הזה — ואיזו אמת עדינה אחת אני יכול לבחור היום במקום הקול המפחיד?\n(הילד/ה שננטש, החלק שהתאכזב, החלק העייף; משפט אחד בלבד)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה להאמין לכל קול שעובר בי."
    ],
      [
      "סגירה",
      "אני לא רוצה להאמין לכל קול שעובר בי."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה המשפט המפחיד — אני עוצר ונושם פעם אחת לפני שאני ממשיך.",
      "כשעולה המשפט המפחיד — אני עוצר ונושם פעם אחת לפני שאני ממשיך."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מאיפה הפחד הזה נולד",
    opening: localizedGenderNode(
      [
      "היום אני מבין שהפחד לא התחיל היום."
    ],
      [
      "היום אני מבין שהפחד לא התחיל היום."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמתי הרגשתי בעבר תחושה דומה?\n(קשר קודם, ילדות, חוויה של דחייה)",
      "מה למדתי אז על אהבה?",
      "האם הכלל הזה עדיין רוצה להיות נכון היום — ואיזה חלק בי עדיין פועל לפי חוק ישן?"
    ],
      [
      "כתיבה\nמתי הרגשתי בעבר תחושה דומה?\n(קשר קודם, ילדות, חוויה של דחייה)",
      "מה למדתי אז על אהבה?",
      "האם הכלל הזה עדיין רוצה להיות נכון היום — ואיזה חלק בי עדיין פועל לפי חוק ישן?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מה שלמדתי אז — לא רוצה לנהל את חיי היום."
    ],
      [
      "סגירה",
      "מה שלמדתי אז — לא רוצה לנהל את חיי היום."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב לעצמי:",
      "אני כותב לעצמי:"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "ההשוואה לאחרים (והשקר שבה)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק למדוד את עצמי לפי הקצב של אחרים."
    ],
      [
      "היום אני מפסיק למדוד את עצמי לפי הקצב של אחרים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת.",
      "“המסע שלי לא אמור להיראות כמו של אף אחד.”"
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת.",
      "“המסע שלי לא אמור להיראות כמו של אף אחד.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nלמי אני משווה את עצמי?",
      "מה אני מדמיין שיש להם שאין לי?",
      "מה אני לא רואה במסע שלהם — ואיזו אמת אחת על הדרך שלי אני מוכן לזכור היום?"
    ],
      [
      "כתיבה\nלמי אני משווה את עצמי?",
      "מה אני מדמיין שיש להם שאין לי?",
      "מה אני לא רואה במסע שלהם — ואיזו אמת אחת על הדרך שלי אני מוכן לזכור היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "השוואה לא בונה אהבה — היא רק שוחקת לב."
    ],
      [
      "סגירה",
      "השוואה לא בונה אהבה — היא רק שוחקת לב."
    ]
    ),
    action: localizedGenderNode(
      "היום אני נמנע/ת מהשוואה אחת ביודעין.",
      "היום אני נמנע/ת מהשוואה אחת ביודעין."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הבושה (“משהו בי לא בסדר”)",
    opening: localizedGenderNode(
      [
      "היום אני נוגע בבושה בלי לתת לה להגדיר אותי."
    ],
      [
      "היום אני נוגע בבושה בלי לתת לה להגדיר אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת.",
      "“בושה לא אומרת אמת. היא אומרת שכואב לי.”"
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת.",
      "“בושה לא אומרת אמת. היא אומרת שכואב לי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הדבר שאני מתבייש/ת בו לגבי זוגיות?",
      "אם חבר אהוב היה אומר את זה על עצמו — מה הייתי אומר לו?",
      "איך אותו משפט נשמע בגרסה אנושית ורכה — ואיזה משפט חמלה אחד אני בוחר היום לעצמי?"
    ],
      [
      "כתיבה\nמה הדבר שאני מתבייש/ת בו לגבי זוגיות?",
      "אם חבר אהוב היה אומר את זה על עצמו — מה הייתי אומר לו?",
      "איך אותו משפט נשמע בגרסה אנושית ורכה — ואיזה משפט חמלה אחד אני בוחר היום לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בושה רוצה שאסתתר.",
      "אני בוחר/ת להישאר."
    ],
      [
      "סגירה",
      "בושה רוצה שאסתתר.",
      "אני בוחר/ת להישאר."
    ]
    ),
    action: localizedGenderNode(
      "יד על חזה + משפט החמלה שלי פעם אחת בלבד.",
      "יד על חזה + משפט החמלה שלי פעם אחת בלבד."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "לפרק את המיתוס “אהבה אחת”",
    opening: localizedGenderNode(
      [
      "היום אני משחרר את הרעיון שהיה רק סיכוי אחד."
    ],
      [
      "היום אני משחרר את הרעיון שהיה רק סיכוי אחד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמאיפה בא הרעיון שיש “אהבה אחת”?",
      "איזו הוכחה יש לי שזה באמת נכון?",
      "איזו אמת רחבה יותר קיימת על קשרים ואנשים — ומה זה אומר עליי אם האהבה הבאה תהיה אחרת, לא העתק?"
    ],
      [
      "כתיבה\nמאיפה בא הרעיון שיש “אהבה אחת”?",
      "איזו הוכחה יש לי שזה באמת נכון?",
      "איזו אמת רחבה יותר קיימת על קשרים ואנשים — ומה זה אומר עליי אם האהבה הבאה תהיה אחרת, לא העתק?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אהבה לא נגמרת כי קשר אחד נגמר."
    ],
      [
      "סגירה",
      "אהבה לא נגמרת כי קשר אחד נגמר."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת:",
      "אני כותב/ת:"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "עצירה באמצע נבואה",
    opening: localizedGenderNode(
      [
      "היום אני מתאמן לעצור נבואה לפני שהיא הופכת לזהות."
    ],
      [
      "היום אני מתאמן לעצור נבואה לפני שהיא הופכת לזהות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזו נבואה אני מריץ/ה על עצמי?",
      "מה הנזק שאני עושה לעצמי כשאני מאמין/ה לה?",
      "איזו אפשרות אחרת קיימת — גם אם אני לא מרגיש/ה אותה עכשיו — ואיזה משפט עצירה אני רוצה לאמץ?"
    ],
      [
      "כתיבה\nאיזו נבואה אני מריץ/ה על עצמי?",
      "מה הנזק שאני עושה לעצמי כשאני מאמין/ה לה?",
      "איזו אפשרות אחרת קיימת — גם אם אני לא מרגיש/ה אותה עכשיו — ואיזה משפט עצירה אני רוצה לאמץ?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "עתיד לא נכתב מפחד — הוא נבנה מצעדים."
    ],
      [
      "סגירה",
      "עתיד לא נכתב מפחד — הוא נבנה מצעדים."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה נבואה — אני אומר/ת את משפט העצירה שלי.",
      "כשעולה נבואה — אני אומר/ת את משפט העצירה שלי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "מה אני כן מחפש באהבה",
    opening: localizedGenderNode(
      [
      "היום אני מזיז פוקוס מפחד — לערך."
    ],
      [
      "היום אני מזיז פוקוס מפחד — לערך."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה חשוב לי באמת בקשר?",
      "איזה צורך שלי לא קיבל מקום בעבר?",
      "איזה ערך אחד אני רוצה להוביל אותי מעכשיו — ואיך אני יכול לתת לעצמי קצת מזה כבר היום?"
    ],
      [
      "כתיבה\nמה חשוב לי באמת בקשר?",
      "איזה צורך שלי לא קיבל מקום בעבר?",
      "איזה ערך אחד אני רוצה להוביל אותי מעכשיו — ואיך אני יכול לתת לעצמי קצת מזה כבר היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אהבה מתחילה ביחסים שאני בונה עם עצמי."
    ],
      [
      "סגירה",
      "אהבה מתחילה ביחסים שאני בונה עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה היום פעולה אחת שמכבדת את הערך שבחרתי.",
      "אני עושה היום פעולה אחת שמכבדת את הערך שבחרתי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "הפחד מדייטים (ולהיות נראה)",
    opening: localizedGenderNode(
      [
      "היום אני נוגע בפחד בלי להיסגר."
    ],
      [
      "היום אני נוגע בפחד בלי להיסגר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הכי מפחיד אותי בדייטים?",
      "מה אני חושש/ת שיראו בי?",
      "מה אני שוכח/ת לגבי הזכות שלי להיות אני — ואיזו אמת אחת אני רוצה לזכור לפני מפגש אנושי?"
    ],
      [
      "כתיבה\nמה הכי מפחיד אותי בדייטים?",
      "מה אני חושש/ת שיראו בי?",
      "מה אני שוכח/ת לגבי הזכות שלי להיות אני — ואיזו אמת אחת אני רוצה לזכור לפני מפגש אנושי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא בוחר/ת/ה להרשים כדי להיות ראוי/ה."
    ],
      [
      "סגירה",
      "אני לא בוחר/ת/ה להרשים כדי להיות ראוי/ה."
    ]
    ),
    action: localizedGenderNode(
      "אם יש מפגש — אני מגיע/ה כמו שאני, בלי תוספות.",
      "אם יש מפגש — אני מגיע/ה כמו שאני, בלי תוספות."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "סבלנות כתכונה רגשית",
    opening: localizedGenderNode(
      [
      "היום אני מתאמן בסבלנות בלי לוותר על עצמי."
    ],
      [
      "היום אני מתאמן בסבלנות בלי לוותר על עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיפה אני ממהר/ת מדי?",
      "מה המחיר של הלחץ הזה?",
      "איך נראית סבלנות שלא מוותרת על החיים — ואיזה קצב נכון לי עכשיו?"
    ],
      [
      "כתיבה\nאיפה אני ממהר/ת מדי?",
      "מה המחיר של הלחץ הזה?",
      "איך נראית סבלנות שלא מוותרת על החיים — ואיזה קצב נכון לי עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קצב לא אומר תקיעות.",
      "קצב אומר הקשבה."
    ],
      [
      "סגירה",
      "קצב לא אומר תקיעות.",
      "קצב אומר הקשבה."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת לעשות דבר אחד היום בלי למהר.",
      "אני בוחר/ת לעשות דבר אחד היום בלי למהר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "להחזיר שליטה (מה כן בידיים שלי)",
    opening: localizedGenderNode(
      [
      "היום אני מצמצם פחד לפעולה."
    ],
      [
      "היום אני מצמצם פחד לפעולה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה לא בשליטתי — ואני משחרר/ת היום?",
      "מה כן בשליטתי? (3 דברים קטנים)",
      "איזה צעד אחד בלבד אני עושה השבוע?"
    ],
      [
      "כתיבה\nמה לא בשליטתי — ואני משחרר/ת היום?",
      "מה כן בשליטתי? (3 דברים קטנים)",
      "איזה צעד אחד בלבד אני עושה השבוע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה"
    ],
      [
      "סגירה"
    ]
    ),
    action: localizedGenderNode(
      "פעולה קטנה",
      "פעולה קטנה"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לאהוב גם כשמפחדים",
    opening: localizedGenderNode(
      [
      "היום אני נותן מקום לשני רגשות יחד."
    ],
      [
      "היום אני נותן מקום לשני רגשות יחד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיך פחד ואהבה יכולים להתקיים יחד בי?",
      "איזה חלק בי רוצה קשר — גם כשהוא מפחד?",
      "מה אני יכול להבטיח לעצמי בתוך קשר עתידי?"
    ],
      [
      "כתיבה\nאיך פחד ואהבה יכולים להתקיים יחד בי?",
      "איזה חלק בי רוצה קשר — גם כשהוא מפחד?",
      "מה אני יכול להבטיח לעצמי בתוך קשר עתידי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אומץ לא אומר שאין פחד.",
      "אומץ אומר שאני לא נותן לו לעצור אותי."
    ],
      [
      "סגירה",
      "אומץ לא אומר שאין פחד.",
      "אומץ אומר שאני לא נותן לו לעצור אותי."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת הבטחה אחת לעצמי.",
      "אני כותב/ת הבטחה אחת לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "תקווה מציאותית",
    opening: localizedGenderNode(
      [
      "היום אני בונה תקווה שלא תלויה בפנטזיה."
    ],
      [
      "היום אני בונה תקווה שלא תלויה בפנטזיה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמהי תקווה אמיתית בשבילי?",
      "מה אני מפסיק/ה לחכות שיקרה “לפני”?",
      "איך נראים חיים טובים גם עכשיו?"
    ],
      [
      "כתיבה\nמהי תקווה אמיתית בשבילי?",
      "מה אני מפסיק/ה לחכות שיקרה “לפני”?",
      "איך נראים חיים טובים גם עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "תקווה נבנית תוך כדי חיים, לא לפני."
    ],
      [
      "סגירה",
      "תקווה נבנית תוך כדי חיים, לא לפני."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה דבר אחד שמחבר אותי לחיים היום.",
      "אני עושה דבר אחד שמחבר אותי לחיים היום."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה ופתיחת דרך",
    opening: localizedGenderNode(
      [
      "היום אני לא מבטיח אהבה — אני מבטיח נוכחות."
    ],
      [
      "היום אני לא מבטיח אהבה — אני מבטיח נוכחות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nשלושה דברים שאני מפסיק/ה להגיד לעצמי על אהבה:",
      "שלושה דברים שאני מתחיל/ה להאמין בהם:",
      "משפט דרך לימים קשים:"
    ],
      [
      "כתיבה\nשלושה דברים שאני מפסיק/ה להגיד לעצמי על אהבה:",
      "שלושה דברים שאני מתחיל/ה להאמין בהם:",
      "משפט דרך לימים קשים:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני אולי לא יודע/ת מתי תגיע אהבה.",
      "אבל אני יודע/ת מי אני כשאני פוגש/ת אותה.",
      "ואני נשאר/ת עם עצמי —",
      "לאט, בשקט, בנוכחות.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני אולי לא יודע/ת מתי תגיע אהבה.",
      "אבל אני יודע/ת מי אני כשאני פוגש/ת אותה.",
      "ואני נשאר/ת עם עצמי —",
      "לאט, בשקט, בנוכחות.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת פעולה אחת שמסמלת פתיחות לחיים — בלי לחץ.",
      "אני בוחר/ת פעולה אחת שמסמלת פתיחות לחיים — בלי לחץ."
    ),
  },
].map(buildNormalizedDay);

export const fearNeverFindLoveAgainBlueprintHe = buildNormalizedPilotBlueprint({
  id: "fear_never_find_love_again_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "fear_never_find_love_again",
  category: "general",
  journeyName: {
    he: "פחד “אני לא אמצא שוב אהבה”",
    en: "Fear: “I Will Not Find Love Again”",
    es: "Miedo: “No volveré a encontrar el amor”",
  },
  days,
});

export default fearNeverFindLoveAgainBlueprintHe;
